import { CSSObject } from '@emotion/react'
import { fontSizes, fonts, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

type HeaderDisplayProps = {
  [key: string]: string
}

type DisplayProps = {
  [key: string]: {
    width: string
    height?: string
    fontSize?: number
  }
}

const errorHeaderFontSize: HeaderDisplayProps = {
  desktopSingle: '32px',
  mobileSingle: '24px',
  desktopStream: '32px',
  mobileStream: '24px',
}

const renderDisplayLayout: DisplayProps = {
  desktopSingle: {
    height: '588px',
    width: '566px',
  },
  mobileSingle: {
    height: '354px',
    width: '341px',
  },
  desktopStream: {
    height: '526px',
    width: '507px',
  },
  mobileStream: {
    height: '292px',
    width: '281px',
  },
}

const renderTextDisplayLayout: DisplayProps = {
  desktopSingle: {
    fontSize: fontSizes.medium,
    width: '350px',
  },
  mobileSingle: {
    fontSize: fontSizes.xSmall,
    width: '263px',
  },
  desktopStream: {
    fontSize: fontSizes.medium,
    width: '350px',
  },
  mobileStream: {
    fontSize: fontSizes.xSmall,
    width: '263px',
  },
}

const getErrorWrapper = (display: string): CSSObject => ({
  alignItems: 'center',
  backgroundColor: colors.n10.base,
  border: `1px solid ${colors.n9.base}`,
  borderRadius: '14px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  ...renderDisplayLayout[display],
  '.kuiper-icon-alert': {
    color: colors.n9.base,
  },
  'h1.kuiper-error-header': {
    color: colors.n4.base,
    fontFamily: fonts.noe,
    fontSize: errorHeaderFontSize[display],
    fontWeight: fontWeights.medium,
    margin: '20px 0 10px 0',
    width: '90px',
  },
  'div.kuiper-error-text': {
    color: colors.n6.base,
    fontFamily: fonts.proxima,
    fontWeight: fontWeights.medium,
    lineHeight: '20px',
    margin: '0 0 20px 0',
    ...renderTextDisplayLayout[display],
  },
  '.kuiper-button': {
    backgroundColor: colors.n7.base,
    borderRadius: '3px',
    color: colors.n4.base,
  },
})

const buttonWrapper: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '180px',
}

const styles = {
  getErrorWrapper,
  buttonWrapper,
}

export { styles }
